import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';
import { GoogleMap, } from "vue3-google-map";

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGoogle',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const Markers = defineAsyncComponent(() => import("@/components/theme/maps/markersMap.vue"))
const DraggableMarker = defineAsyncComponent(() => import("@/components/theme/maps/draggableMarker.vue"))
const GooglePolyline = defineAsyncComponent(() => import("@/components/theme/maps/googlePolyline.vue"))
const TrianglePolygon = defineAsyncComponent(() => import("@/components/theme/maps/trianglePolygon.vue"))
let desc = "Display a map at a specified location and zoom level."
let desc1 = "Display a map with labels in a foreign language"
let desc2 = "Display a map highlighting points of interest"
let desc3 = "Display a map highlighting points of interest"
let desc4 = "Display a map with a line showing a known route"
let desc5 = "Display a map highlighting a region or area"

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Maps",
      title: "Google Maps"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Map at a specified location",
          span: "true",
          spanClass: _unref(desc)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GoogleMap), {
              center: { lat: 20.5937, lng: 78.9629 },
              zoom: 12,
              style: {"width":"auto","height":"500px"}
            })
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Multi-language support",
          span: "true",
          spanClass: _unref(desc1)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GoogleMap), {
              center: { lat: 20.5937, lng: 78.9629 },
              zoom: 6,
              style: {"width":"auto","height":"500px"},
              options: {
                    region: 'VI',
                    language: 'vi',
                }
            })
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Marker on the Map",
          span: "true",
          spanClass: _unref(desc2)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Markers))
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Draggable Marker",
          span: "true",
          spanClass: _unref(desc3)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DraggableMarker))
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Polyline on the Map",
          span: "true",
          spanClass: _unref(desc4)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(GooglePolyline))
          ]),
          _: 1
        }, 8, ["spanClass"]),
        _createVNode(_unref(Card9), {
          colClass: "col-lg-6 ",
          cardhaderClass: "pb-0 title-header",
          title: "Polygon on the Map",
          span: "true",
          spanClass: _unref(desc5)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TrianglePolygon))
          ]),
          _: 1
        }, 8, ["spanClass"])
      ])
    ])
  ], 64))
}
}

})